import React, { FC } from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';
import AlternativeItineraryDoubleCardLayerTitle from './AlternativeItineraryDoubleCardLayerTitle';
import AlternativeItineraryDoubleCardLayerCard from '@components/AlternativeItineraryDoubleCard/components/AlternativeItineraryDoubleCardLayerCard/AlternativeItineraryDoubleCardLayerCard';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { AlternativeItineraryDoubleCardLayerTopSectionProps } from './types';

const AlternativeItineraryDoubleCardLayerTopSection: FC<
  AlternativeItineraryDoubleCardLayerTopSectionProps
> = ({
  itinerary,
  isBrokenFlow,
  nonIssuable,
  isUnavailable = true,
  trackingHandler,
}) => {
  const { t } = useTranslation();
  const titleContent = isBrokenFlow
    ? 'alternativeBrokenFlow.title.issue'
    : nonIssuable
    ? 'alternativeItinerary.nonIssuable.layer.unavailable.title'
    : 'alternativeItinerary.improvement.issuable.layer.title';
  return (
    <Box
      marginBottom={'big'}
      paddingX={'1x_big'}
      sx={{
        '*': {
          boxShadow: 'none !important',
        },
      }}
    >
      <AlternativeItineraryDoubleCardLayerTitle sx={{ marginBottom: '16px' }}>
        {t(titleContent)}
      </AlternativeItineraryDoubleCardLayerTitle>

      <AlternativeItineraryDoubleCardLayerCard
        isAlternativeItineraryOnModal
        itinerary={itinerary}
        nonIssuable={nonIssuable}
        isBrokenFlow={isBrokenFlow}
        isClickable={false}
        isAlternativeItinerary={false}
        isSelectedItinerary={true}
        hasAlternativeItineraryDecorator={false}
        isAlternativeTopSection={true}
        isUnavailable={nonIssuable && isUnavailable}
        trackingHandler={trackingHandler}
      />
    </Box>
  );
};

export default AlternativeItineraryDoubleCardLayerTopSection;
